/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <group-activity-list v-if="isGroup && !storeId"/>
    <store-activity-lists v-else/>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import GroupActivityList from './GroupActivityList'
  import StoreActivityLists from './StoreActivityLists'

  export default {
    name: 'GroupActivityBus',
    components: { StoreActivityLists, GroupActivityList },
    computed: {
      ...mapGetters(['storeInfo','isGroup']),
      storeId() { return this.$route.query.store },
    }
  }
</script>
